import { createContext, useContext, useEffect, useState } from "react";

const en = {
  navStatus: "Status", navRegister: "Register", navClients: "Clients", navFaq: "FAQ",
  navWeb: "Web client ↗", getUin: "Get UIN", offline: "offline",
  heroA: "Uh-oh! Your numbered", heroB: "identity is", heroC: "back online.",
  heroSub: "KICQ is a revived ICQ network running the original OSCAR protocol. Grab a fresh UIN in seconds and log in with QIP, Miranda, ICQ 2003b or Pidgin — just like in 2003.",
  heroRegister: "Register new UIN", heroWeb: "Open web client", addrCopied: "Server address copied",
  stEyebrow: "// 01 — live server", stTitle: "OSCAR server status", stPing: "Ping again",
  stStatus: "Status", stHost: "Host", stPort: "Port", stLatency: "Latency", stUins: "UINs via KICQ", ms: "ms",
  CHECKING: "CHECKING", ONLINE: "ONLINE", OFFLINE: "OFFLINE",
  flapOk: "FLAP hello received · channel 1 · protocol v1", flapWait: "TCP open, awaiting FLAP", flapNone: "No response from server",
  regEyebrow: "// 02 — registration", regTitle: "Claim your UIN",
  regSub: "No email confirmation, no phone number. Just a password and a few seconds.",
  regSteps: [
    ["Pick a password", "4–16 characters. Keep it to 8 if you use ICQ 2003b or older."],
    ["We talk OSCAR", "Our bridge opens a FLAP session to the server and sends a registration request (SNAC 17,04)."],
    ["Get your number", "The server replies with your brand-new UIN. Log in with any classic client."],
  ],
  fPassword: "Password *", fConfirm: "Confirm password *", fNick: "Nickname", fEmail: "Email", optional: "optional",
  pwHint: "Classic clients use up to 8 characters",
  fCaptcha: "Enter the code from the image *", captchaPh: "CODE", captchaRefresh: "New code", captchaFail: "Failed to load",
  errCaptchaEmpty: "Enter the 5-character code from the image.", errCaptcha: "Wrong code from the image. Try the new one.",
  errLen: "Password must be 4-16 characters.", errChars: "Use Latin letters, digits and symbols only (no spaces).",
  errMatch: "Passwords do not match.", errNet: "Could not reach the server. Try again.",
  errRate: "Too many registrations from your address. Try again in an hour.", errOscar: "OSCAR server error:",
  submit: "Register my UIN", submitting: "Talking to OSCAR server…",
  pwNote: "Your password is sent directly to the OSCAR server and never stored by KICQ.",
  yourUin: "Your new UIN", welcome: "Welcome,", sServer: "Server", sPort: "Port", sPassword: "Password",
  writeDown: "Write down your UIN and password — they cannot be recovered.",
  copyUin: "Copy UIN", uinCopied: "UIN copied", loginWeb: "Log in on kicq.su",
  soundOn: "Uh-oh on", soundOff: "Uh-oh off", another: "Register another",
  clEyebrow: "// 03 — connect", clTitle: "Set up your client",
  clients: {
    qip: ["Open Settings → Connection", "Server: {host}", "Port: {port}", "Enter your UIN and password, then connect"],
    miranda: ["Options → Network → ICQ", "Login server: {host}", "Port: {port}, SSL off", "Fill in UIN & password in Account"],
    icq2003: ["Main → Preferences → Connections", "Host: {host}", "Port: {port}", "Log in with your UIN"],
    pidgin: ["Accounts → Add → Protocol ICQ", "Username: your UIN", "Advanced → Server {host}, port {port}", "Disable SSL / clientLogin"],
  },
  faqEyebrow: "// 04 — faq", faqTitle: "Questions, 2003-style",
  faqs: [
    ["Is this the original ICQ?", "No. KICQ is an independent, community-run server that speaks the classic OSCAR protocol, so old ICQ clients work again."],
    ["Can I recover a lost password?", "Not yet. Registration is anonymous — save your UIN and password somewhere safe."],
    ["Why is my password limited?", "Older clients (ICQ 2003b and earlier) only send the first 8 characters. Keep it short if you plan to use them."],
    ["Does KICQ store my password?", "No. The password goes straight to the OSCAR server inside the registration packet. We only keep your UIN and optional nickname."],
  ],
  tagline: "I seek you, again.", footWeb: "kicq.su — web client",
  themeRetro: "Win98", themeModern: "Modern",
  rtWelcome: "KICQ 2000b — Welcome", rtStatusT: "Server Status", rtWizard: "ICQ Registration Wizard",
  rtClientsT: "Client Setup", rtFaqT: "Help Topics", rtStart: "Start", rtNext: "Next >",
  rtSignal: "Signal", rtCongrats: "Congratulations! Your new ICQ# is:", rtUins: "Registered via KICQ",
  rtError: "Error", rtWebT: "kicq.su", rtMenuSwitch: "Switch to Modern", rtShutdown: "Uh-oh!",
  rtSecurity: "Security check", telegram: "Telegram",
};

const ru = {
  navStatus: "Статус", navRegister: "Регистрация", navClients: "Клиенты", navFaq: "Вопросы",
  navWeb: "Веб-клиент ↗", getUin: "Получить UIN", offline: "офлайн",
  heroA: "О-оу! Ваш номер", heroB: "снова", heroC: "в сети.",
  heroSub: "KICQ — возрождённая сеть ICQ на оригинальном протоколе OSCAR. Получите новый UIN за пару секунд и входите через QIP, Miranda, ICQ 2003b или Pidgin — как в 2003 году.",
  heroRegister: "Зарегистрировать UIN", heroWeb: "Открыть веб-клиент", addrCopied: "Адрес сервера скопирован",
  stEyebrow: "// 01 — сервер онлайн", stTitle: "Статус сервера OSCAR", stPing: "Проверить снова",
  stStatus: "Статус", stHost: "Хост", stPort: "Порт", stLatency: "Пинг", stUins: "UIN через KICQ", ms: "мс",
  CHECKING: "ПРОВЕРКА", ONLINE: "ОНЛАЙН", OFFLINE: "ОФЛАЙН",
  flapOk: "Получен FLAP hello · канал 1 · протокол v1", flapWait: "TCP открыт, ожидание FLAP", flapNone: "Сервер не отвечает",
  regEyebrow: "// 02 — регистрация", regTitle: "Получите свой UIN",
  regSub: "Без подтверждения почты и номера телефона. Только пароль и пара секунд.",
  regSteps: [
    ["Придумайте пароль", "От 4 до 16 символов. Не больше 8, если пользуетесь ICQ 2003b или старше."],
    ["Мы говорим на OSCAR", "Наш шлюз открывает FLAP-сессию с сервером и отправляет запрос регистрации (SNAC 17,04)."],
    ["Получите номер", "Сервер возвращает ваш новый UIN. Входите через любой классический клиент."],
  ],
  fPassword: "Пароль *", fConfirm: "Повторите пароль *", fNick: "Ник", fEmail: "Email", optional: "необязательно",
  pwHint: "Классические клиенты используют до 8 символов",
  fCaptcha: "Введите код с картинки *", captchaPh: "КОД", captchaRefresh: "Новый код", captchaFail: "Не загрузилось",
  errCaptchaEmpty: "Введите 5 символов с картинки.", errCaptcha: "Неверный код с картинки. Попробуйте новый.",
  errLen: "Пароль должен быть от 4 до 16 символов.", errChars: "Только латинские буквы, цифры и символы (без пробелов).",
  errMatch: "Пароли не совпадают.", errNet: "Не удалось связаться с сервером. Попробуйте ещё раз.",
  errRate: "Слишком много регистраций с вашего адреса. Попробуйте через час.", errOscar: "Ошибка сервера OSCAR:",
  submit: "Зарегистрировать UIN", submitting: "Связываемся с сервером OSCAR…",
  pwNote: "Пароль отправляется напрямую на сервер OSCAR и не хранится в KICQ.",
  yourUin: "Ваш новый UIN", welcome: "Добро пожаловать,", sServer: "Сервер", sPort: "Порт", sPassword: "Пароль",
  writeDown: "Запишите UIN и пароль — восстановить их невозможно.",
  copyUin: "Копировать UIN", uinCopied: "UIN скопирован", loginWeb: "Войти на kicq.su",
  soundOn: "Звук вкл", soundOff: "Звук выкл", another: "Ещё один UIN",
  clEyebrow: "// 03 — подключение", clTitle: "Настройте клиент",
  clients: {
    qip: ["Откройте Настройки → Соединение", "Сервер: {host}", "Порт: {port}", "Введите UIN и пароль, подключайтесь"],
    miranda: ["Настройки → Сеть → ICQ", "Сервер входа: {host}", "Порт: {port}, SSL выкл", "Укажите UIN и пароль в учётной записи"],
    icq2003: ["Main → Preferences → Connections", "Хост: {host}", "Порт: {port}", "Войдите со своим UIN"],
    pidgin: ["Учётные записи → Добавить → ICQ", "Имя пользователя: ваш UIN", "Дополнительно → сервер {host}, порт {port}", "Отключите SSL / clientLogin"],
  },
  faqEyebrow: "// 04 — вопросы", faqTitle: "Вопросы в стиле 2003",
  faqs: [
    ["Это оригинальная ICQ?", "Нет. KICQ — независимый сервер сообщества на классическом протоколе OSCAR, поэтому старые клиенты ICQ снова работают."],
    ["Можно восстановить пароль?", "Пока нет. Регистрация анонимна — сохраните UIN и пароль в надёжном месте."],
    ["Почему пароль ограничен?", "Старые клиенты (ICQ 2003b и ранее) отправляют только первые 8 символов. Используйте короткий пароль, если планируете ими пользоваться."],
    ["KICQ хранит мой пароль?", "Нет. Пароль уходит прямо на сервер OSCAR в пакете регистрации. Мы храним только UIN и необязательный ник."],
  ],
  tagline: "I seek you — снова.", footWeb: "kicq.su — веб-клиент",
  themeRetro: "Win98", themeModern: "Модерн",
  rtWelcome: "KICQ 2000b — Добро пожаловать", rtStatusT: "Состояние сервера", rtWizard: "Мастер регистрации ICQ",
  rtClientsT: "Настройка клиента", rtFaqT: "Справка", rtStart: "Пуск", rtNext: "Далее >",
  rtSignal: "Сигнал", rtCongrats: "Поздравляем! Ваш новый номер ICQ:", rtUins: "Зарегистрировано через KICQ",
  rtError: "Ошибка", rtWebT: "kicq.su", rtMenuSwitch: "Современный вид", rtShutdown: "О-оу!",
  rtSecurity: "Проверка безопасности",
};

const dict = { en, ru };
const I18nCtx = createContext(null);

const initialLang = () =>
  localStorage.getItem("kicq-lang") || (navigator.language?.toLowerCase().startsWith("ru") ? "ru" : "en");

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);
  useEffect(() => {
    localStorage.setItem("kicq-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (k) => dict[lang][k] ?? en[k] ?? k;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
